module.exports = __webpack_public_path__ + "static/media/TREK A WHILE SMALL.00c7e61e.png";